import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Theme,
  makeStyles,
  createStyles,
} from "@material-ui/core";
import { ArticleEditor } from "./ArticleEditor";
import { ArticlePaperModal } from "./ArticlePaperModal";
import { useSelector } from "react-redux";

interface IArticleModalViewProps {
  show: boolean;
  onHide(): void;
}

export const ArticleModalView: React.FC<IArticleModalViewProps> = ({
  show,
  onHide,
}) => {
  const classes = useStyles();

  const articleState = useSelector((state) => state.article);
  const { article } = articleState;

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="lg"
      fullWidth
      className={classes.root}
    >
      <DialogContent className={classes.root}>
        <Box
          display="flex"
          width={1}
          height={1}
          overflow="hidden"
          maxHeight={"800px"}
          bgcolor="whitesmoke"
        >
          <ArticleEditor article={article} onHide={onHide} />
          <ArticlePaperModal article={article} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      paddingTop: "0 !important",
      padding: "0 !important",
    },
  })
);
